var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopRecording(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 56.5,
    r: 56.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.669 41.032a2.315 2.315 0 0 1 3.13.163c.87.87.925 2.199.163 3.125l-.163.18-12.992 13 12.992 13h-.001c.936.897.92 2.378.046 3.296l-.009.01-.001-.001a2.316 2.316 0 0 1-3.308 0L56.498 60.804l-12.991 13h-.001a2.318 2.318 0 0 1-3.31 0 2.309 2.309 0 0 1 0-3.304l12.992-13-12.992-12.963a2.31 2.31 0 0 1 0-3.306 2.318 2.318 0 0 1 3.31 0l12.99 12.964 12.993-13 .18-.163z",
    fill: "#fff",
    stroke: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopRecording);
export default __webpack_public_path__ + "static/media/stop_recording.b0226a3182c7902df50dac439a88cded.svg";
export { ForwardRef as ReactComponent };